export const ACTIVE_MODE = {
  GRADES: "GRADES",
  CLASSES: "CLASSES",
  MEMBERS: "MEMBERS",
};

export const GROUP_BY_OPTIONS = [
  { value: ACTIVE_MODE.CLASSES, labelKey: "common:classes" },
  { value: ACTIVE_MODE.GRADES, labelKey: "common:grades" },
  { value: ACTIVE_MODE.MEMBERS, labelKey: "common:members" },
];
